import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';

import syncLoadingImage from './assets/sync_loading_image.svg';
import { CardSx, DescriptionSx, ImageSx, TitleSx } from './styles';
import { SyncLoadingCardProps } from './types';

const SyncLoadingCard = (props: SyncLoadingCardProps) => {
  const { 'data-testid': dataTestId, hasBorder = false } = props;

  return (
    <Card sx={CardSx(hasBorder)} data-testid={dataTestId}>
      <Box component="img" src={syncLoadingImage} alt="Sync in progress" sx={ImageSx} />
      <Typography sx={TitleSx}>Sync in progress...</Typography>
      <Typography sx={DescriptionSx}>
        We're currently syncing assets from Jamf to allwhere, this may take up to 30 minutes – please check back shortly.
      </Typography>
    </Card>
  );
};

export default SyncLoadingCard; 
